import MetricConfigValidator from "@viz-ui/services/metrics/metricConfigValidatorService";

class MetricValidator {
  isValid(metric) {
    return !!(metric.name() && MetricConfigValidator.isValid(metric.metricConfig()));
  }
}

export default new MetricValidator();
